/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <form @submit.prevent="handleRecovery" class="auth-form">
        <label>Correo para recuperación</label>
        
        <input 
            type="email" 
            placeholder="Ingresa tu correo institucional" 
            v-model="email"
            :class="{ 'input-error': error }" 
            @input="limpiarMensajes" 
            required 
            :disabled="isLoading" 
        />
        
        <p v-if="error" class="error-message">Por favor ingresa un correo válido.</p>

        <p v-if="serverError" class="error-message">{{ serverError }}</p>
        <p v-if="successMessage" class="success-message">{{ successMessage }}</p>

        <div class="links-group">
            <div class="link" @click="$emit('change-view', 'login')">Volver al Login</div>
        </div>

        <button type="submit" :disabled="botonDeshabilitado">
            {{ isLoading ? 'Enviando...' : 'Enviar enlace de recuperación' }}
        </button>
    </form>
</template>

<script>
import userService from '@/services/userService'; 

export default {
    name: 'RecoveryForm',
    data() {
        return {
            email: '',
            error: false,          
            isLoading: false,      
            serverError: '',       
            successMessage: ''     
        };
    },
    computed: {
        botonDeshabilitado() {
            return this.isLoading || this.successMessage.length > 0;
        }
    },
    methods: {
        limpiarMensajes() {
            this.error = false;
            this.serverError = '';
            this.successMessage = ''; 
        },
        async handleRecovery() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!this.email || !emailRegex.test(this.email)) {
                this.error = true;
                return;
            }

            this.isLoading = true;
            this.serverError = '';
            this.successMessage = '';

            try {
                await userService.requestPasswordReset(this.email);
                
                this.successMessage = '¡Listo! Si el correo existe, hemos enviado las instrucciones.';
                this.email = ''; 
                
            } catch (err) {
                console.error("Error en recuperación:", err);
                if (err.response && err.response.data && err.response.data.error) {
                    this.serverError = err.response.data.error;
                } else {
                    this.serverError = 'Ocurrió un error de conexión. Intenta más tarde.';
                }
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.auth-form { width: 80%; display: flex; flex-direction: column; }
label { font-size: 20px; margin-top: 20px; }
input { padding: 8px; margin-top: 5px; border: none; border-radius: 10px; font-size: 14px; height: 30px; }

input:disabled { background-color: #e0e0e0; cursor: not-allowed; }

button { width: 100%; background: #29b9f6; color: white; border: none; padding: 12px; margin-top: 65px; cursor: pointer; border-radius: 5px; font-size: 16px; font-weight: bold; transition: 0.3s ease; }
button:hover { background: #e55050; }

button:disabled { background-color: #8bbdd3; cursor: not-allowed; }

.links-group { margin-top: 20px; }
.link { font-size: 14px; color: #0056b3; cursor: pointer; text-decoration: underline; }
.input-error { border: 2px solid red; }
.error-message { color: red; font-size: 14px; margin-top: 5px; }

.success-message {
    color: #28a745;
    font-size: 14px;
    margin-top: 10px;
    font-weight: bold;
    background-color: #d4edda;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #c3e6cb;
}
</style>